import { Toro } from '../../common/enumerations';

export class FireAndWaitForNotificationCommandResponse
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
            this.WhenScheduledForDelivery = new Date(json['WhenScheduledForDelivery']);
        }
    }

    AnticipatedTimeToComplete = 0;
    FailureCode: number = null;
    Header: string = null;
    MessageId: string = null;
    MessageSentSuccessfully = false;
    NotificationTypeToExpect: Toro.NotificationTypeCode = 0;
    ParentId = 0;
    TargetId: number = null;
    WhenScheduledForDelivery: Date;

    get NotificationTypeToExpectString(): string
    {
        return Toro.NotificationTypeCode[this.NotificationTypeToExpect];
    }
}
